<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_NAME']"
    />
    <uf_name />

    <div class="content-title content-mb-14 uf_name">
      3. Программа финансовой поддержки
      <VDropdown trigger="click" placement="bottom" popperClass="custom-popper">
        <a class="info-holder-icon" />
        <template #popper>
          <span
            class="custom-popper-content"
            v-html="this.project.UF_HELP.FIELDS.STEP2['UF_SUPPORT_PROG_ID']"
          />
        </template>
      </VDropdown>
      <a
        v-show="$parent.getProgramCode() === 'working'"
        @click="$parent.showWorkingModal = !$parent.showWorkingModal"
        class="icon-help icon-help-working"
      />
    </div>
    <uf_support_prog_id />

    <template v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">
      <div class="content-title content-mb-14">
        4. Направление финансирования
      </div>
      <uf_direction_financing_id></uf_direction_financing_id>
    </template>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">5</span><span v-else>4</span>. Оказывал ли региональный фонд развития промышленности методологическую
      и/или информационную помощь при подготовке заявки в Фонд развития
      промышленности
      <span class="icon-warning"></span>
      <VDropdown
        tag="span"
        trigger="click"
        placement="bottom"
        popperClass="custom-popper"
        style="display: inline"
      >
        <a class="icon-help icon-help-l40" />
        <template #popper>
          <div class="custom-popper-content">
            {{ h4tooltip }}
          </div>
        </template>
      </VDropdown>
    </div>
    <uf_is_reg_fond_help></uf_is_reg_fond_help>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">6</span><span v-else>5</span>. В структуре владения уставным капиталом преобладающее
      участие имеет паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">7</span><span v-else>6</span>. Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">8</span><span v-else>7</span>. Сроки займа, мес.</div>
    <uf_month_return></uf_month_return>

    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">9</span><span v-else>8</span>. Отрасль промышленности</div>
    <uf_industry_id></uf_industry_id>

    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">10</span><span v-else>9</span>. Подотрасль промышленности</div>
    <uf_sub_industry_id></uf_sub_industry_id>

    <div v-if="$parent.getProgramCode() === 'working'">
      <template v-if="project.UF_SETTING.IS_VIEW_CONFIRMATION_PART_FEDERAL_PROJECT == 1">
        <div class="content-title content-mb-14">
          <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">11</span><span v-else>10</span>. Подтверждение участия в Федеральном проекте "Производительность труда"<template v-if="isRobotizationDirection">/ Федеральном проекте "Развитие промышленной робототехники и автоматизации производства"</template>
        </div>
        <ConfirmFederalProject></ConfirmFederalProject>
      </template>
      <template v-else>
        <div class="content-title content-mb-14">
          <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">11</span><span v-else>10</span>. Подтверждение участия в Национальном проекте "Производительность
          труда"
        </div>
        <ConfirmNationalProject></ConfirmNationalProject>
      </template>

    </div>

    <!-- add item 10 - UF_ACTUAL_TECH_ID  -->
    <div
      v-if="$parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3"
    >
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">11</span><span v-else>10</span>. Включение продукции проекта в перечень высокотехнологичной
        продукции. Укажите код производимой высокотехнологичной продукции в
        соответствии с приказом Минпромторга России от 11.06.2020 № 1863
      </div>
      <HighTechListMPT></HighTechListMPT>
    </div>
    <div></div>
    <div class="content-title content-mb-14">
      <span
        v-if="
          $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
        "
      >11.</span
      >
      <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">12</span><span v-else>11</span>.</span>
      <span v-else>11.</span> Аннотация проекта
    </div>
    <uf_annotation></uf_annotation>

    <div class="content-title content-mb-14">
      <span
        v-if="
          $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
        "
      >12.</span
      >
      <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">13</span><span v-else>12</span>.</span>
      <span v-else>11.</span> Имеющийся результат по проекту
    </div>
    <uf_available_results></uf_available_results>

    <div class="content-title content-mb-14">
      <span
        v-if="
          $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
        "
      >13.</span
      >
      <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">14</span><span v-else>13</span>.</span>
      <span v-else>12.</span> Место реализации проекта
    </div>
    <place></place>

    <div class="content-title content-mb-14">
      <span style="float:left;">
        <span
          v-if="
            $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
          "
        >14.</span
        >
        <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">15</span><span v-else>14</span>.</span>
        <span v-else>13.</span>
        Продукция производится на спецтерритории
      </span>
      <span style="float: left;margin-top: 12px;margin-left: 10px;">
        <label class="switch">
          <input type="checkbox" v-model="project.UF_IS_PRODACTION_SP_TERR" />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <SpecialPlace v-if="project.UF_IS_PRODACTION_SP_TERR"></SpecialPlace>

    <HelpFiledStep2
      :text="
        `${
          $parent.getProgramCode() === 'working'
            ? ($parent.project.UF_DIRECTION_FINANCING_ID > 0)?16:15
            : $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
            ? 16
            : 14
        }. Ключевые исполнители (поставщик продукции, услуг, на которого приходится
      не менее 20% от суммы займа)`
      "
      :helpText="this.project.UF_HELP.FIELDS.STEP2['BLOCK_COAUTHOR']"
    />
    <subcontractors />

    <div v-if="$parent.getProgramCode() === 'working'">
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">17</span><span v-else>16</span>. Продукция, комплектующим изделием которой является продукт проекта (в соотв. с приложением к ПП РФ от 17.07.2015 №719)
      </div>
      <PromProducts></PromProducts>
    </div>

    <div v-if="$parent.getProgramCode() !== 'complectyushie'">
      <template v-if="$parent.project.UF_SETTING && $parent.project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT">
        <div class="content-title content-mb-14">
          <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">18</span><span v-else>17</span>. Информация о продукции проекта
          <VDropdown
            tag="span"
            trigger="click"
            placement="bottom"
            popperClass="custom-popper"
            style="display: inline"
          >
            <a class="icon-help icon-help-l40" />
            <template #popper>
              <div class="custom-popper-content">
                Продукты проекта, перечисленные в резюме должны быть синхронизированы с перечнем из финансовой модели
              </div>
            </template>
          </VDropdown>
        </div>
        <ProjectOkpdProducts></ProjectOkpdProducts>
      </template>
      <template v-else>
        <div class="content-title content-mb-14">
          <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">18</span><span v-else>17</span>. Информация о продукции (в соответствии с перечнем ОКПД)
        </div>
        <okpd></okpd>
      </template>
    </div>
    <div v-else>
      <div class="content-title content-mb-14">
        <span
          v-if="
          $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
        "
        >16.</span
        >
        <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">16</span><span v-else>15</span>.</span>
        <span v-else>15.</span>
         Комплектующее изделие (в соотв. с ПП РФ от 17.07.2015 №719)
      </div>
      <PromProducts></PromProducts>
    </div>


    <div class="content-title content-mb-14">
      <span
        v-if="
          $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
        "
      >17.</span
      >
      <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">19</span><span v-else>18</span>.</span>
      <span v-else>16.</span>

      <template v-if="$parent.getProgramCode() === 'working'">
        Включение продукции проекта в Перечни критической продукции / отраслевые планы импортозамещения
      </template>
      <template v-else>
      Включение проекта в отраслевые планы импортозамещения
      <template
        v-if="
          project.UF_SETTING.SHOW_IMPORT_PLAN_ID &&
            project.UF_SETTING.SHOW_IMPORT_PLAN_ID.length > 0
        "
      >/ Перечни критической продукции
      </template
      >
      </template>
    </div>
    <import_plan>tree_group_med_oborudovanie</import_plan>

    <template
      v-if="
        $parent.getProgramCode() === 'working' &&
          project.UF_SETTING.IS_VIEW_HIGH_TECH == 1
      "
    >
      <div class="content-title content-title-2line content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">20</span><span v-else>19</span>. Продукция Проекта относится к высокотехнологичной
      </div>
      <HighTechProducts></HighTechProducts>
    </template>

    <template
      v-if="
        $parent.getProgramCode() === 'working' &&
          project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK != 1
      "
    >
      <div class="content-title content-title-2line content-mb-14">
        <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span>.</span>
        <span v-else><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">20</span><span v-else>19</span>.</span>
        Наличие рынка для продукции проекта и положительная динамика его
        развития
      </div>
      <Uf_is_availability_market></Uf_is_availability_market>
    </template>

    <template v-if="$parent.getProgramCode() === 'working'">
      <div class="content-title content-title-2line content-mb-14">
        <template v-if="project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1">
          <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">
            <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21.</span><span v-else>20.</span>
          </span>
          <span v-else><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">20</span><span v-else>19</span>.</span>
        </template>
        <span v-else><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span>.</span> Продукция включена в Перечень критических
        комплектующих изделий, утверждаемых МВК
      </div>
      <criticalCompMVK></criticalCompMVK>
    </template>

    <template
      v-if="
        $parent.getProgramCode() === 'stankostroi' ||
          $parent.getProgramCode() === 'konversia'
      "
    >
      <HelpFiledStep2
        :text="
          `${
            $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
              ? 18
              : $parent.getProgramCode() === 'working'
              ? $parent.project.UF_DIRECTION_FINANCING_ID > 0?21:20
              : $parent.project.UF_DIRECTION_FINANCING_ID > 0?18:17
          }. Соответствуют ли технологии, применяемые в рамках проекта, правилам НДТ`
        "
        :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_IS_NDT']"
      />
      <uf_is_ndt />
    </template>

    <template
      v-if="project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1"
    >
      <div class="content-title content-title-2line content-mb-14">
        <span v-if="$parent.getProgramCode() === 'working' && project.UF_SETTING.IS_VIEW_HIGH_TECH !== 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span></span>
        <span v-else><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">22</span><span v-else>21</span></span>. Компания включена в Реестр производителей товаров с использованием вторичного сырья?
      </div>
      <Uf_is_reestr_using_rm></Uf_is_reestr_using_rm>
    </template>

    <template v-if="project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1">
      <uf_okpo>
        <span v-if="$parent.getProgramCode() === 'stankostroi'">19.</span>
        <template
          v-else-if="
            $parent.getProgramCode() === 'working' &&
              project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1
          "
        >
          <span
            v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1 && project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>22</span>.</span>
          <span v-else-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">22</span><span v-else>21</span>.</span>
          <span v-else-if="project.UF_SETTING.IS_VIEW_HIGH_TECH !== 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">22</span><span v-else>21</span>.</span>
          <span v-else>19.</span>
        </template>
        <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span>.</span>
        <span v-else-if="$parent.getProgramCode() === 'konversia'">19.</span>
        <span v-else>18.</span>
      </uf_okpo>
    </template>

    <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
      <div class="content-title content-mb-14">
        <span v-if="$parent.getProgramCode() === 'stankostroi'">{{ 19 + okpoShift }}.</span>
        <template
          v-else-if="
            $parent.getProgramCode() === 'working' &&
              project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1
          "
        >
          <span
            v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1 && project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 21 + okpoShift }}</span><span v-else>{{ 22 + okpoShift }}</span>.</span>
          <span v-else-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 22 + okpoShift }}</span><span v-else>{{ 21 + okpoShift }}</span>.</span>
          <span v-else-if="project.UF_SETTING.IS_VIEW_HIGH_TECH !== 1"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 22 + okpoShift }}</span><span v-else>{{ 21 + okpoShift }}</span>.</span>
          <span v-else>{{ 19 + okpoShift }}.</span>
        </template>
        <span v-else-if="$parent.getProgramCode() === 'working'"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 21 + okpoShift }}</span><span v-else>{{ 20 + okpoShift }}</span>.</span>
        <span v-else-if="$parent.getProgramCode() === 'konversia'">{{ 19 + okpoShift }}.</span>
        <span v-else>{{ 18 + okpoShift }}.</span>
        Финансовые показатели организации
      </div>
      <financialIndicator></financialIndicator>
      <dividendsIndicator :isMainPunct="false"></dividendsIndicator>
    </template>

    <div v-if="project.UF_INDICATOR_VERSION === 1">
      <div v-if="countriesLoaded">
        <div class="content-title content-mb-14">
          <span
            v-if="
              $parent.getProgramCode() === 'konversia' && project.UF_VERSION < 3
            "
          >19.</span
          >
          <span v-else>17.</span>
          Сбыт продукции проекта, обеспечивающий выход на целевой объем продаж
        </div>
        <export_countries></export_countries>
      </div>
    </div>
    <div
      class="row myrow content-mb-42"
      v-if="project.UF_INDICATOR_VERSION === 1"
    >
      <div class="col-xs-12 mycol">
        <textarea
          :disabled="$parent.projectDisabled"
          v-model="project.UF_SALE"
          class="i-main-style t-dop-style i-wid-50"
          placeholder="Укажите планируемые объемы продаж/спроса, наличие инструментов реализации продукции проекта, перечень договоренностей по реализации продукции проекта: соглашения, предварительные соглашения, переговоры и т.п."
        ></textarea>
      </div>
    </div>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Okpd from "@/components/project/form/partial/okpd";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import Uf_is_prp_not_analog from "@/components/project/form/partial/uf_is_prp_not_analog";
import Uf_is_strategically_medicines from "@/components/project/form/partial/uf_is_strategically_medicines";
import Uf_is_production_industrial from "@/components/project/form/partial/uf_is_production_industrial";
import Uf_is_ndt from "@/components/project/form/partial/uf_is_ndt";
import PromProducts from "@/components/project/form/partial/PromProducts";
import ConfirmNationalProject from "@/components/project/form/partial/ConfirmNationalProject";
import SpecialPlace from "@/components/project/form/partial/SpecialPlace";
import Uf_region_id from "@/components/project/form/partial/uf_region_id";
import ActualTechList from "@/components/project/form/partial/ActualTechList";
import HighTechListMPT from "@/components/project/form/partial/HighTechListMPT";
import Uf_type_product_list from "@/components/project/form/partial/uf_type_product_list";
import Uf_main_competitor_abroad from "@/components/project/form/partial/uf_main_competitor_abroad";
import Uf_main_main_manufacturers_abroad from "@/components/project/form/partial/uf_main_main_manufacturers_abroad";
import Uf_demand_year_products_project from "@/components/project/form/partial/uf_demand_year_products_project";
import Uf_base_year from "@/components/project/form/partial/uf_base_year";
import criticalCompMVK from "@/components/project/form/partial/CriticalCompMVK";
import Uf_is_availability_market from "@/components/project/form/partial/uf_is_availability_market";
import FinancialIndicator from "@/components/project/form/partial/FinancialIndicator";
import HighTechProducts from "@/components/project/form/partial/HighTechProducts";
import { Dropdown as VDropdown } from "floating-vue";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";
import Uf_okpo from "@/components/project/form/partial/uf_okpo";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";
import Uf_is_reestr_using_rm from "@/components/project/form/partial/uf_is_reestr_using_rm.vue";
import ConfirmFederalProject from "@/components/project/form/partial/ConfirmFederalProject.vue";
import dividendsIndicator from "@/components/project/form/partial/DividendsIndicator.vue";
import Uf_direction_financing_id from "@/components/project/form/partial/uf_direction_financing_id.vue";

export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    Uf_okpo,
    Uf_direction_financing_id,
    dividendsIndicator,
    Uf_is_reestr_using_rm,
    Uf_region_id,
    SpecialPlace,
    PromProducts,
    ConfirmNationalProject,
    Uf_is_reg_fond_help,
    Uf_is_prp_not_analog,
    Uf_is_strategically_medicines,
    Uf_is_production_industrial,
    Export_countries,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    ProjectOkpdProducts,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    Uf_is_ndt,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    criticalCompMVK,
    VueTagsInput,
    ActualTechList,
    HighTechListMPT,
    Uf_type_product_list,
    Uf_main_competitor_abroad,
    Uf_main_main_manufacturers_abroad,
    Uf_demand_year_products_project,
    Uf_base_year,
    Uf_is_availability_market,
    FinancialIndicator,
    HighTechProducts,
    VDropdown,
    HelpFiledStep2,
    uf_is_prevails_mutual_invest_fund,
    ConfirmFederalProject
  },
  data() {
    return {
      selectedTags: [],
      hCoExecutorTooltip:
        "Заполнение данного поля позволит Вам ускорить процедуру проведения акцептов платежей после получения средств займа.",
      h14tooltipShow: false,
      h4tooltip:
        "Успешная реализация Вашего проекта важна для региона. Если Вы хотите предоставить Региональному фонду доступ к текущей заявке, получить консультационную поддержку и помощь, выберите «Да» в выпадающем списке:",
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      countriesLoaded: false,
      h18tooltip:
        "Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта \"Цифровизация промышленности\"",
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        "                                • Раздел \"ИТ-консалтинг (разработка и системная интеграция)\" рэнкинга \"Список крупнейших российских консалтинговых групп и компаний\" Эксперт-РА (https://raex-a.ru/);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru)."
    };
  },

  async created() {
    this.siteUrl = AUTH_URL;
    await this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "tree/vid_prom_products",
      "sp_list_actual_technology",
      "sp_ndt",
      "sp_type_productions",
      "sp_confirmation_part_national_project",
      "tree/sp_orders_high_tech_industry",
      "sp_direction_financing"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    if (this.project.FINANCIAL_INDICATORS.items.length === 0) {
      this.project.FINANCIAL_INDICATORS.items = new Object();
    }
    this.project.FINANCIAL_INDICATORS.INDICATORS_ID.forEach(function(
      indicator
    ) {
      if (
        typeof m.project.FINANCIAL_INDICATORS.items[indicator] === "undefined"
      ) {
        Vue.set(m.project.FINANCIAL_INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.FINANCIAL_INDICATORS.yearStart;
        year <= m.project.FINANCIAL_INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.FINANCIAL_INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.FINANCIAL_INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_FINANCIAL_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store.dispatch(FETCH_DIRECTORY, ["country"]).then(() => {
      this.project.UF_EXPORT_COUNTRY_ID.forEach(function(cId) {
        this.directory.country.forEach(function(c) {
          if (cId === c.ID) {
            this.selectedTags.push(c.NAME);
          }
        }, this);
      }, this);
      this.countriesLoaded = true;
    }, this);

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {
        /*
        if (this.$parent.getProgramCode() === "stankostroi") {
          this.project.UF_OKPD_CLASS_ID = this.getInfoproduction(28);
          this.project.UF_OKPD_PODCLASS_ID = this.getInfoproduction(28, 28.4);
          this.project.UF_INDUSTRY_ID = this.getIndustry(28);
          this.project.UF_SUB_INDUSTRY_ID = this.getIndustry(
            28,
            "production_stanki"
          );
        }

         */
        if (this.$parent.getProgramCode() === "cifrovizaciya") {
          if (
            this.project.UF_STAVKA_PR_YEAR === "" ||
            this.project.UF_STAVKA_PR_YEAR === 0
          ) {
            this.project.UF_STAVKA_PR_YEAR = 5;
          }
        }
      }, this);
  },

  methods: {
    onTagAdded(slug) {
      if (slug > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.push(
          this.directory.country[parseInt(slug)].ID
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      this.directory.country.forEach(function(c) {
        if (c.NAME === slug) {
          rem = c.ID;
        }
      });
      if (rem > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_EXPORT_COUNTRY_ID.splice(index, 1);
          }
        }, this);
      }
    },
    getInfoproduction(code, subcode) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        if (subcode) {
          let tt = t[0].CHILD.filter(c => c.CODE === subcode);
          if (tt.length > 0 && tt[0].URL !== null) {
            return tt[0].ID;
          }
        }
        return t[0].ID;
      }
      return "";
    },
    getIndustry(code, subcode) {
      let t = this.directory.tree_industry.filter(c => c.CODE === code);
      if (t.length > 0 && t[0].URL !== null) {
        if (subcode) {
          let tt = t[0].CHILD.filter(c => c.CODE === subcode);
          if (tt.length > 0 && tt[0].URL !== null) {
            return tt[0].ID;
          }
        }
        return t[0].ID;
      }
      return "";
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    }
  },
  computed: {
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    countries() {
      let els = this.directory.country.filter(function(el) {
        for (let i = 0; i < this.project.UF_EXPORT_COUNTRY_ID.length; i++) {
          if (el.ID === this.project.UF_EXPORT_COUNTRY_ID[i]) {
            return true;
          }
        }
        return false;
      }, this);
      return els;
    },
    countryTags() {
      let countries = {};
      this.directory.country.forEach(function(el, k) {
        countries[k] = el.NAME;
      }, this);
      return countries;
    },
    isRobotizationDirection() {
      let id = this.project.UF_DIRECTION_FINANCING_ID;
      if (!(id > 0)) return false;
      let dir = (this.directory.sp_direction_financing || []).find(function(
        item
      ) {
        return item.ID == id;
      });
      return !!dir && dir.CODE === "robotization_of_production";
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
